"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyDetailType$ = exports.CompanyDetailType$outboundSchema = exports.CompanyDetailType$inboundSchema = exports.CompanyDetailType = void 0;
const z = __importStar(require("zod"));
exports.CompanyDetailType = {
    Company: "company",
    Society: "society",
};
/** @internal */
exports.CompanyDetailType$inboundSchema = z.nativeEnum(exports.CompanyDetailType);
/** @internal */
exports.CompanyDetailType$outboundSchema = exports.CompanyDetailType$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompanyDetailType$;
(function (CompanyDetailType$) {
    /** @deprecated use `CompanyDetailType$inboundSchema` instead. */
    CompanyDetailType$.inboundSchema = exports.CompanyDetailType$inboundSchema;
    /** @deprecated use `CompanyDetailType$outboundSchema` instead. */
    CompanyDetailType$.outboundSchema = exports.CompanyDetailType$outboundSchema;
})(CompanyDetailType$ || (exports.CompanyDetailType$ = CompanyDetailType$ = {}));
//# sourceMappingURL=companydetailtype.js.map